"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Spinner: function() {
        return _index.Spinner;
    },
    renderSpinner_unstable: function() {
        return _index.renderSpinner_unstable;
    },
    spinnerClassNames: function() {
        return _index.spinnerClassNames;
    },
    useSpinnerStyles_unstable: function() {
        return _index.useSpinnerStyles_unstable;
    },
    useSpinner_unstable: function() {
        return _index.useSpinner_unstable;
    }
});
const _index = require("./components/Spinner/index");
